module.exports = "https://trybtryb-legacy.web.app/img/resources.81499308.webp";